import React, { createContext, useState , useMemo, useContext} from 'react';
//import { getAuth, getIdToken } from "firebase/auth";
import { auth } from "../lib/firebaseApp"
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from '../hooks/useLocalStorage';

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage('user', null)
    const [token, setToken] = useState()
   const navigate = useNavigate();

    const login = async (email, password, callback_error) => {
        try {
            //console.log(email, password)
            signInWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    console.log(userCredential)
                    
                    // Signed in
                    var _user = userCredential.user;
                    var _id_token = userCredential.user.accessToken
                    console.log("USER: ", _user)
                    console.log("ID_TOKEN: ", _id_token)

                    setUser(_user)
                    setToken(_id_token)
                    //navigate("/menu")
                })
                .catch((error) => {
                    callback_error(error)
                    //var errorCode = error.code;
                    //var errorMessage = error.message;
                    //console.error("Login error:\n\tcode: ", errorCode, "\n\tmessage: ", errorMessage)
                });

        } catch (e) {
            callback_error(e)
            console.log(e);
        }
    }


    const logout = async () => {
        try {
            console.log("LOGOUT")
            signOut(auth).then(() => {
                // Sign-out successful.
                setToken()
                setUser()
            }).catch((error) => {
                // An error happened.
                console.error(error);
            });
            navigate("/", { replace: true });

        } catch (e) {
            console.error(e);
        }
    }

    const value = useMemo(
        () => ({
            user,
            login,
            logout,
        }),
        [user]
    );
    return (
        <AuthContext.Provider
            value={value}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider

export const useAuth = () => {
    return useContext(AuthContext);
};